import React from "react"
import * as styles from "../advantages.module.scss"
import { AdvantageCardProps } from "../types"

export const AdvantageCard = ({ title, description, Icon }: AdvantageCardProps) => (
  <div className={styles.card}>
    {Icon && <Icon alt="" className={styles.icon} />}
    <div>
      {title && <h3 className={styles.title}>{title}</h3>}
      {description && <p className={styles.description}>{description}</p>}
    </div>
  </div>
)
